// extracted by mini-css-extract-plugin
export default {"importantNote":"RenderEmailVerification_importantNote__5LcOP","closeBanner":"RenderEmailVerification_closeBanner__QBSEV","verifyEmail":"RenderEmailVerification_verifyEmail__Ymt0t"};